import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import type { OverdueSummaryManager } from '@ctct/application-layer';
import { useBalance, useBillingAccount } from '@ctct/state-server-layer';

import './overdue-summary-widget.scss';

interface Props {
  initializer: Pick<OverdueSummaryManager, 'overdueSummaryInit'>;
}

export const useOverdueSummaryWidget = ({ initializer }: Props) => {
  const balanceQuery = useBalance();
  const billingAccountQuery = useBillingAccount();
  const { t } = useTranslation();

  const componentProps = useMemo(
    () =>
      initializer.overdueSummaryInit({
        queries: [balanceQuery, billingAccountQuery],
        t,
      }),
    [initializer, balanceQuery, billingAccountQuery, t]
  );

  return componentProps;
};

export type OverdueSummaryWidgetProps = ReturnType<typeof useOverdueSummaryWidget>;
